import { useState, useEffect, useCallback } from 'react';
import '../../Styles/ArtistRoot.css';
import '../../Styles/Admin.css';

import COUNTRIES from '../../utils/Countries';
import PODCAST_GENRES from '../../utils/PodcastGender';

import { AiOutlinePlusCircle } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import izenuAPI from '../../services/izenuAPI';

export default function Podcasters() {
    const [creatingAccount, setCriatingAccount] = useState(false);
    const [artists, setArtists] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [showForm, setShowForm] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    // Returns true when the account was created, so the form knows to reset.
    const insertArtist = useCallback(async (data) => {
        setCriatingAccount(true);
        try {
            const { data: r } = await izenuAPI.post('/distributor/artist/createPodcasterAccount.php', data);
            if (!r.response) {
                alert(r.message || "Impossível adicionar o podcaster, tenta mais tarde!");
                return false;
            }
            try {
                const { data: emailResp } = await izenuAPI.post(`${process.env.REACT_APP_API_URL}/mail/sendNewArtistEmail.php`, { pwd: data.pwd1, user_email: data.email });
                alert(emailResp.response
                    ? 'Conta criada com sucesso, as credenciais de acesso foram enviadas para o email do podcaster!'
                    : 'Conta criada com sucesso, mas não foi possível enviar as credenciais de acesso por email!');
            } catch {
                alert('Conta criada com sucesso, mas não foi possível enviar as credenciais de acesso por email!');
            }
            return true;
        } catch (error) {
            console.log(error);
            alert('Ocorreu um erro ao criar a conta do podcaster!');
            return false;
        } finally {
            setCriatingAccount(false);
        }
    }, []);
    const listArtists = useCallback(async () => {
        setLoading(true);
        try {
            const distributor_id = localStorage.getItem('id');
            const { data: r } = await izenuAPI.get('/distributor/artist/listPodcasters.php?distributor_id=' + distributor_id);
            if (r.response) {
                setArtists(r.playlists || []);
            }
        } catch (error) {
            console.log(error);
        }
        setLoading(false);
    }, []);
    const filteredArtists = artists.filter(e => {
        if (!searchTerm) return true;
        const term = searchTerm.toLowerCase();
        return (e.artist_name || '').toLowerCase().includes(term) ||
            (e.first_name || '').toLowerCase().includes(term) ||
            (e.last_name || '').toLowerCase().includes(term);
    });

    const renderUsers = () => {
        if (filteredArtists.length === 0) {
            return (
                <p className="py-12 text-center text-sm text-gray-500">
                    {searchTerm ? `Nenhum podcaster encontrado para "${searchTerm}".` : 'Ainda não tens podcasters.'}
                </p>
            );
        }
        return (
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3">
                {filteredArtists.map((e) => (
                    <Link to={`/podcaster/${e.artist_id}`} key={e.artist_id}
                        className="flex items-center gap-3 rounded-xl border border-gray-200 bg-white p-3 transition hover:border-amber-400 hover:shadow-sm">
                        <div className="h-12 w-12 shrink-0 overflow-hidden rounded-full bg-gray-200">
                            {e.cover ? (
                                <img src={e.cover} alt="" className="h-full w-full object-cover" loading="lazy" />
                            ) : (
                                <svg className="h-12 w-12 text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
                                </svg>
                            )}
                        </div>
                        <div className="min-w-0 flex-1 text-left">
                            <p className="truncate font-semibold text-gray-900">{e.artist_name}</p>
                            <p className="truncate text-sm text-gray-500">{[e.first_name, e.last_name].filter(Boolean).join(' ')}</p>
                        </div>
                        <div className="shrink-0 text-right">
                            <p className="text-sm font-semibold text-gray-800">{Number(e.number_of_followers || 0).toLocaleString('pt-PT')}</p>
                            <p className="text-xs text-gray-400">seguidores</p>
                        </div>
                    </Link>
                ))}
            </div>
        );
    };

    useEffect(() => {
        listArtists();
    }, [listArtists]);

    if (loading && artists.length === 0) {
        return (<div className="justify-center block items-center flex flex-col h-full flex-1 p-5 rounded-lg" style={{ height: '100%' }}>
            <div role="status">
                <svg aria-hidden="true" class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-yellow-400" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                </svg>
                <h1 className="text-amber-500 font-light text-3xl">A carregar...</h1>
            </div>
        </div>)
    }
    return (<div className="mx-auto max-w-6xl p-3 sm:p-6 text-left">
        <div className="mb-4 flex flex-wrap items-center gap-3">
            <div className="min-w-0 flex-1">
                <h1 className="text-xl sm:text-2xl font-bold text-gray-900">Podcasters</h1>
                <p className="text-sm text-gray-500">{artists.length} {artists.length === 1 ? 'podcaster' : 'podcasters'} na distribuidora</p>
            </div>
            <button type="button" onClick={() => setShowForm(v => !v)}
                className="flex items-center gap-2 rounded-lg bg-amber-500 px-4 py-2.5 text-sm font-medium !text-white hover:bg-amber-600">
                {showForm
                    ? <span aria-hidden="true" className="text-lg leading-none">×</span>
                    : <AiOutlinePlusCircle size={18} aria-hidden="true" />}
                {showForm ? 'Fechar' : 'Adicionar podcaster'}
            </button>
        </div>

        {showForm && (
            <section className="mb-6 rounded-xl border border-gray-200 bg-white p-4 sm:p-6">
                <h2 className="mb-1 text-lg font-semibold text-gray-900">Novo podcaster</h2>
                <p className="mb-4 text-sm text-gray-500">A conta é criada já ligada à tua distribuidora e as credenciais são enviadas para o email do podcaster.</p>
                <Formik
                    initialValues={{
                        artist_name: '',
                        first_name: '',
                        last_name: '',
                        email: '',
                        phone: '',
                        pwd1: '',
                        pwd2: '',
                        city: '',
                        bio: '',
                        link: '',
                        gender: 'male',
                        birth_date: '',
                        genre: '',
                                            country: 'Angola'
                    }}
                    onSubmit={async (values, { setSubmitting, resetForm }) => {
                        const created = await insertArtist(values);
                        setSubmitting(false);
                        if (created) {
                            resetForm();
                            setShowForm(false);
                            listArtists();
                        }
                    }}
                    validate={values => {
                        const errors = {};
                        if (values.pwd1 && values.pwd2 && values.pwd1 !== values.pwd2) {
                            errors.pwd2 = 'As palavras-passe não coincidem.';
                        }
                        return errors;
                    }}
                    validationSchema={Yup.object({
                        artist_name: Yup.string().max(50, 'No máximo 50 caracteres.').required('Campo obrigatório.'),
                        first_name: Yup.string().max(50, 'No máximo 50 caracteres.').required('Campo obrigatório.'),
                        last_name: Yup.string().max(50, 'No máximo 50 caracteres.').required('Campo obrigatório.'),
                        email: Yup.string().email('Endereço de email inválido.').required('Campo obrigatório.'),
                        phone: Yup.string().max(13, 'No máximo 13 caracteres.').required('Campo obrigatório.'),
                        pwd1: Yup.string().min(5, 'No mínimo 5 caracteres.').required('Campo obrigatório.'),
                        pwd2: Yup.string().required('Campo obrigatório.'),
                    })}
                >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => {
                        const field = (name, label, props = {}, wide = false, hint) => (
                            <label className={`block ${wide ? 'sm:col-span-2' : ''}`}>
                                <span className="mb-1 block text-sm font-medium text-gray-700">{label}</span>
                                {props.as === 'textarea' ? (
                                    <textarea name={name} value={values[name]} onChange={handleChange} onBlur={handleBlur} rows={4} placeholder={props.placeholder} className={inputCls} />
                                ) : props.as === 'select' ? (
                                    <select name={name} value={values[name]} onChange={handleChange} onBlur={handleBlur} className={inputCls}>{props.children}</select>
                                ) : (
                                    <input name={name} value={values[name]} onChange={handleChange} onBlur={handleBlur} type={props.type || 'text'} placeholder={props.placeholder} autoComplete={props.autoComplete} className={inputCls} />
                                )}
                                {touched[name] && errors[name]
                                    ? <span className="mt-1 block text-xs text-red-600">{errors[name]}</span>
                                    : hint ? <span className="mt-1 block text-xs text-gray-500">{hint}</span> : null}
                            </label>
                        );
                        return (
                            <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} className="space-y-6">
                                <fieldset>
                                    <legend className="mb-3 text-xs font-semibold uppercase tracking-wide text-gray-500">Podcast e responsável</legend>
                                    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                                        {field('artist_name', 'Nome do podcast *', { placeholder: 'Como aparece na app' }, true)}
                                        {field('first_name', 'Primeiro nome *')}
                                        {field('last_name', 'Último nome *')}
                                        {field('genre', 'Categoria do podcast', { as: 'select', children: [
                                            <option key="" value="">Escolhe uma categoria</option>,
                                            ...PODCAST_GENRES.map(g => <option key={g.value} value={g.value}>{g.label}</option>),
                                        ] })}
                                        {field('gender', 'Sexo', { as: 'select', children: [
                                            <option key="male" value="male">Masculino</option>,
                                            <option key="female" value="female">Feminino</option>,
                                        ] })}
                                        {field('birth_date', 'Data de nascimento', { type: 'date' })}
                                                                                {field('bio', 'Descrição do podcast', { as: 'textarea', placeholder: 'Sobre o que é o podcast…' }, true)}
                                    </div>
                                </fieldset>

                                <fieldset>
                                    <legend className="mb-3 text-xs font-semibold uppercase tracking-wide text-gray-500">Contacto e origem</legend>
                                    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                                        {field('email', 'Email *', { type: 'email', placeholder: 'email@exemplo.com', autoComplete: 'off' })}
                                        {field('phone', 'Telefone *', { type: 'tel', placeholder: '+244 9XX XXX XXX' })}
                                        {field('country', 'País de origem', { as: 'select', children: COUNTRIES.map(c => <option key={c.name} value={c.name}>{c.name}</option>) })}
                                        {field('city', 'Cidade', { placeholder: 'Luanda' })}
                                        {field('link', 'Link', { type: 'url', placeholder: 'https://…' }, true, 'Site ou rede social do podcast (opcional).')}
                                    </div>
                                </fieldset>

                                <fieldset>
                                    <legend className="mb-3 text-xs font-semibold uppercase tracking-wide text-gray-500">Acesso</legend>
                                    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                                        {field('pwd1', 'Palavra-passe *', { type: showPassword ? 'text' : 'password', autoComplete: 'new-password' })}
                                        {field('pwd2', 'Repetir palavra-passe *', { type: showPassword ? 'text' : 'password', autoComplete: 'new-password' })}
                                    </div>
                                    <label className="mt-2 inline-flex items-center gap-2 text-sm text-gray-600">
                                        <input type="checkbox" checked={showPassword} onChange={e => setShowPassword(e.target.checked)} className="h-4 w-4 rounded border-gray-300 text-amber-500 focus:ring-amber-500" />
                                        Mostrar palavras-passe
                                    </label>
                                </fieldset>

                                <div className="flex flex-col-reverse gap-2 border-t pt-4 sm:flex-row sm:justify-end">
                                    <button type="button" onClick={() => setShowForm(false)} className="rounded-lg !border !border-solid border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50">Cancelar</button>
                                    <button type="submit" disabled={isSubmitting || creatingAccount} className="rounded-lg bg-amber-500 px-4 py-2.5 text-sm font-medium !text-white hover:bg-amber-600 disabled:opacity-50">{creatingAccount ? 'A criar conta…' : 'Criar conta do podcaster'}</button>
                                </div>
                            </form>
                        );
                    }}
                </Formik>
            </section>
        )}

        <div className="mb-4">
            <div className="search-distributors-input">
                <input
                    type="search"
                    placeholder="Pesquisar por nome do podcast ou responsável…"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ padding: '8px 0', fontSize: 14 }}
                />
            </div>
        </div>

        {renderUsers()}
    </div>);
}

const inputCls = 'block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-amber-500 focus:ring-amber-500';
